import { firebaseApp } from '../../firebase/firebase';
import {
  USER_SIGNUP,
  USER_SIGNUP_SUCCESSFUL,
  USER_SIGNUP_REJECTED,
  USER_LOGIN,
  USER_LOGIN_SUCCESSFUL,
  USER_LOGIN_REJECTED,
  USER_LOGOUT,
  USER_LOGOUT_SUCCESSFUL,
  USER_LOGOUT_REJECTED,
  USER_AUTH,
  USER_AUTH_SUCCESSFUL,
  USER_AUTH_REJECTED,
  FIELD_CHANGED,
} from '../../_actions/types';

export const signUpUser = (email, password, phone, title, details, checked) => {
  return (dispatch) => {
    dispatch({ type: USER_SIGNUP });
    firebaseApp
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then(user => {
      console.log(user.user);
      onboardingSetup(user.user, checked, title, details, phone)
    })
  }
}

export const loginUser = ( email, password, checked) => {
  return (dispatch) => {
    dispatch({ type: USER_LOGIN });
    firebaseApp.auth().signInWithEmailAndPassword(email, password)
    .catch(() => loginUserFail(dispatch))
  };
}

// const loginUserSuccess = (dispatch, user, checked, phone) => {
//   const updates = {}
//   updates[`users/${user.uid}/meta/email`] = user.email
//   updates[`users/${user.uid}/meta/name`] = user.displayName? user.displayName : user.email
//   updates[`users/${user.uid}/meta/photo`] = user.photoURL? user.photoURL : ''
//   updates[`users/${user.uid}/meta/id`] = user.uid
//   updates[`users/${user.uid}/meta/realtor`] = checked
//   updates[`users/${user.uid}/meta/phone`] = phone
//   firebaseApp.database().ref().update(updates).then(() => {
//     dispatch({ type: USER_LOGIN_SUCCESSFUL, payload:{user,phone} })
//   })
// }

const loginUserFail = (dispatch) => {
  dispatch({ type: USER_LOGIN_REJECTED })
}

const onboardingSetup = (user, checked, title, details, phone) => {
  console.log(user);
  const userId = user.uid;
  const Ref = firebaseApp.database().ref('tasks').push();
  const Key = Ref.key;
  const updates = {}
  updates[`tasks/${Key}/title`] = title;
  updates[`tasks/${Key}/key`] = Key;
  updates[`tasks/${Key}/done`] = false;
  updates[`tasks/${Key}/inProgressUser`] = "";
  updates[`tasks/${Key}/details`] = details;
  updates[`tasks/${Key}/dueDate`] = "";
  updates[`tasks/${Key}/userId`] = userId;
  updates[`tasks/${Key}/users/${userId}`] = true;
  updates[`tasks/${Key}/userEmail`] = user.email;
  updates[`tasks/${Key}/fileCount`] = 0;
  updates[`tasks/${Key}/timerTotal`] = 0;
  updates[`users/${userId}/tasks/${Key}`] = true;
  updates[`users/${userId}/meta/email`] = user.email;
  updates[`users/${userId}/meta/name`] = user.displayName? user.displayName : user.email;
  updates[`users/${userId}/meta/photo`] = user.photoURL? user.photoURL : '';
  updates[`users/${userId}/meta/id`] = userId;
  updates[`users/${userId}/meta/realtor`] = checked;
  updates[`users/${userId}/meta/phone`] = phone;
  updates[`users/${userId}/meta/hours`] = 3600;
  firebaseApp.database().ref().update(updates);
}


export const fieldChanged = (key,value) => {
  return { type: FIELD_CHANGED, key, value}
}

export const checkAuth = () => {
  return dispatch => {
    firebaseApp.auth().onAuthStateChanged((user) => {
      if (user) {
        firebaseApp.database().ref(`users/${user.uid}`).on('value', snapshot => {
          userAuthed(dispatch, user, snapshot.val().meta.realtor, snapshot.val().meta.phone, snapshot.val().onboarding, snapshot.val().meta.hours)
        })
      } else {
        userNotAuthed(dispatch, user)
      }
    })
  }
}

const userAuthed = (dispatch, user, realtor, phone, onboarding="true", hours) => {
  dispatch({ type: USER_AUTH_SUCCESSFUL, user: user, realtor: realtor, phone: phone, onboarding: onboarding, hours:hours })
}

const userNotAuthed = (dispatch, user) => {
  dispatch({ type: USER_AUTH_REJECTED })
}

export const logoutUser = () => {
  return (dispatch, getState) => {
    firebaseApp.auth().signOut()
    .then(() => logoutUserSuccess(dispatch, getState)).catch(() => logoutUserFail(dispatch))
  }
}

const logoutUserSuccess = (dispatch, getState) => {
  dispatch({ type: USER_LOGOUT_SUCCESSFUL })
}


const logoutUserFail = (dispatch) => {
  dispatch({ type: USER_LOGOUT_REJECTED })
}



// WEBPACK FOOTER //
// ./src/components/auth/auth_actions.js